import { useParams, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { useState, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "./pagar.css";
import api_cnpj from "../../services/api_cnpj";
import MaskedInput from "../maskedinput/maskedinput";
import { formatar, mask } from "../../services/react-format";

function Pagar(props){
   //console.log('Pagar: '+ cont_cgc_cpf);
  const [searchParams    , setSearchParams]    = useSearchParams();
     
  const [cod_transacao   , setCodTransacao   ]= useState(-1);
  const [cont_id         , setContID         ]= useState(-1);
  const [trans_descr     , setTransDescr     ]= useState("");
  const [trans_dt_vencto , setTransDtVencto  ]= useState("");
  const [trans_valor     , setTransValor     ]= useState(0);
  const [trans_status    , setTransStatus    ]= useState("");
  const [alterado        , setAlterado       ]= useState(false);
  const [cont_cgc_cpf    , setContCgc_cpf    ]= useState("");
  const [cont_nome       , setContNome       ]= useState("");
  const [cont_endereco   , setContEndereco   ]= useState("");
  const [cont_numero     , setContNumero     ]= useState("");
  const [cont_complemento, setContComplemento]= useState("");
  const [cont_bairro     , setContBairro     ]= useState("");
  const [cont_cep        , setContCep        ]= useState("");
  const [cont_cidade     , setContCidade     ]= useState("");
  const [cont_uf         , setContUf         ]= useState("");
  const [cont_residencial, setContResidencial]= useState("");
  const [cont_email      , setContEmail      ]= useState("");

  var CNPJCliente    = searchParams.get("cnpj");
  var UsuarioSpartan = searchParams.get("usuario");  

  useEffect(() => {
    setCodTransacao(props.cod_transacao);
    setContID(props.cont_id);
    setTransDescr(props.trans_descr);
    setTransDtVencto(props.trans_dt_vencto);
    setTransStatus(props.trans_status);
    setTransValor(props.trans_valor);
    setContCgc_cpf(props.cont_cgc_cpf);
    setContNome(props.cont_nome);
    setContEndereco(props.cont_endereco);
    setContNumero(props.cont_numero);
    setContComplemento(props.cont_complemento);
    setContBairro(props.cont_bairro);
    setContCep(props.cont_cep);
    setContCidade(props.cont_cidade);
    setContUf(props.cont_uf);
    setContResidencial(props.cont_residencial);
    setContEmail(props.cont_email);
  },[props])


  // function handleValor(e){
  //   let obj = formatar(e.target,"money"); //target = objeto input que coloquei a funcao la em baixo
  //   console.log(obj)
  //   setTransValor(obj.value);
  //   setAlterado(true);    
  // }
  function handleCnpj(e){
    let obj=formatar(e.target,"cnpjorcpf");
    setContCgc_cpf(obj.value);
    //  e.target.value.length>=13 ? PesquisaCNPJ(e.target.value):<></>
     setAlterado(true)    
  };

  function PesquisaCNPJ(cnpj, inputid){
    cnpj = cnpj.replaceAll("/","").replaceAll(".","").replaceAll("-","");
    //console.log(encodeURI(cnpj));
    if (cnpj == "") {
      console.log("CNPJ não informado"); 
      console.log("ID campo:"+ inputid); 
      return;
    };

    if (cnpj !== undefined) {
      api.get("/erp/lead",{params: {cnpj}})
      .then((resp) => {  //aguarda a resposta do comando get anterior          
        //console.log(JSON.stringify(resp.data));
        document.getElementById(inputid).value = resp.data.cont_nome;
        console.log("Pesquisa Lead retornou: " + resp.data.cont_nome);
        console.log("Campo alterado: " + inputid);
        setContCgc_cpf(resp.data.cont_cgc_cpf);
        setContNome(resp.data.cont_nome);
        setContEndereco(resp.data.cont_endereco);
        setContNumero(resp.data.cont_numero);
        setContComplemento(resp.data.cont_complemento);
        setContBairro(resp.data.cont_bairro);
        setContCep(resp.data.cont_cep);
        setContCidade(resp.data.cont_cidade);
        setContUf(resp.data.cont_uf);
        setContResidencial(resp.data.cont_residencial);
        setContEmail(resp.data.cont_email);      
      })
    .catch((err) => {     
                      //alert('Não foi possível encontrar os dados para este CNPJ') ;
                      setContCgc_cpf("");
                      setContNome("Não encontrado");
                      setContEndereco("");
                      setContNumero("");
                      setContComplemento("");
                      setContBairro("");
                      setContCep("");
                      setContCidade("");
                      setContUf("");
                      setContResidencial("");
                      setContEmail("");
                    }
          );

    if ((cont_nome == "")||(cont_nome == "Não encontrado"))
    {
      api_cnpj.get("/"+encodeURI(cnpj))
      .then((resp) => {  //aguarda a resposta do comando get anterior          
          //console.log(JSON.stringify(resp.data));
          console.log(resp.data.nome);
          document.getElementById(inputid).value =resp.data.nome;

          setContCgc_cpf(resp.data.cnpj);
          setContNome(resp.data.nome);
          setContEndereco(resp.data.logradouro);
          setContNumero(resp.data.numero);
          setContComplemento(resp.data.complemento);
          setContBairro(resp.data.bairro);
          setContCep(resp.data.cep);
          setContCidade(resp.data.municipio);
          setContUf(resp.data.uf);
          setContResidencial(resp.data.telefone);
          setContEmail(resp.data.email);      
      })
      .catch((err) => {
          //alert('Não foi possível encontrar os dados para este CNPJ') ;
          setContCgc_cpf("");
          setContNome("Não encontrado");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
      });
  
    } 
    else {
          setContCgc_cpf("");
          setContNome("");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
        };
  
    };


  };

    
  function ExcluirPagar(props){
    confirmAlert({
        title: 'Exclusão',
        message: 'Confirma exclusão?',
        buttons: [
          {
            label: 'Sim',
            onClick: (codtrans=props.cod_transacao) => {              
              //console.log(props);
              api.delete("/erp/pagar?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+codtrans)
              .then((resp) => {  //aguarda a resposta do comando get anterior
                //console.log(resp.data);
                if (resp.data.status == 'OK') {
                  props.onClose();
                }else{
                  alert(resp.data.mensagem);
                }
              })
              .catch((err) => {
                  alert('Falha ao excluir ID: '+props.cod_transacao + ' Mensagem: '+err) ;
              });
            }
            
          },
          {
            label: 'Não',
            onClick: () => {}
          }
        ]
      });
  };

  function SalvarPagar(props){   
    console.log("Chammando função SalvarPagar...");
    const pagar_params = {
      usuario: UsuarioSpartan,
      cod_transacao,
      cont_id,
      trans_descr,
      trans_dt_vencto,
      trans_status,
      trans_valor,
      cont_cgc_cpf,
      cont_nome,
      cont_endereco,
      cont_numero,
      cont_complemento,
      cont_bairro,
      cont_cep,
      cont_cidade,
      cont_uf,
      cont_residencial,
      cont_email
    };        
      if (cont_nome == "") {
        { 
          alert("Realize a pesquisa por CNPJ para preenchimento dos campos");
          return;
        }
      };
      console.log("trans_dt_vencto: " +trans_dt_vencto);
      if ((trans_dt_vencto == undefined)||(trans_dt_vencto == "")) {
        { 
          alert("Verifique a data de vencimento "+trans_dt_vencto);
          return;
        }
      };
      if ((trans_valor == undefined) ||(trans_valor == 0)) {
        { 
          alert("Verifique o valor");
          return;
        }
      };

    api.post("/erp/pagar?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,pagar_params)
    .then((resp) => {  //aguarda a resposta do comando get anterior
      console.log("Resp do post na rota /erp/pagar: "+resp.data);
      if (resp.status == 201){
        props.onClose();
        setAlterado(false);
        setCodTransacao(-1);
        setContID(-1);
        setTransDescr("");
        setTransDtVencto("");
        setTransStatus("");
        setTransValor("");
        setContCgc_cpf("");
        setContNome("");
        setContEndereco("");
        setContNumero("");
        setContComplemento("");
        setContBairro("");
        setContCep("");
        setContCidade("");
        setContUf("");
        setContResidencial("");
        setContEmail("");
  
      } else {alert("O seguinte erro foi retornado: "+resp.data.mensagem);}

    })
    .catch((err) => {
        alert('Falha ao gravar dados: '+err);
    });


  };
  
  function SalvarAlteracaoPagar(props){   
    console.log("Chammando função SalvarAlteracaoPagar...");
    const pagar_params = {
      usuario: UsuarioSpartan,
      cod_transacao,
      cont_id,
      trans_descr,
      trans_dt_vencto,
      trans_status,
      trans_valor,
      cont_cgc_cpf,
      cont_nome,
      cont_endereco,
      cont_numero,
      cont_complemento,
      cont_bairro,
      cont_cep,
      cont_cidade,
      cont_uf,
      cont_residencial,
      cont_email
    };        
      if (cont_nome == "") {
        { 
          alert("Realize a pesquisa por CNPJ para preenchimento dos campos");
          return;
        }
      };
      console.log("trans_dt_vencto: " +trans_dt_vencto);
      if ((trans_dt_vencto == undefined)||(trans_dt_vencto == "")) {
        { 
          alert("Verifique a data de vencimento "+trans_dt_vencto);
          return;
        }
      };
      if ((trans_valor == undefined) ||(trans_valor == 0)) {
        { 
          alert("Verifique o valor");
          return;
        }
      };

      api.post("/erp/pagar?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,pagar_params)
      .then((resp) => {  //aguarda a resposta do comando get anterior
        console.log("Resp do post na rota /erp/pagar: "+resp.data);
        if (resp.status == 201){
          props.onClose();
          setAlterado(false);
          setCodTransacao(-1);
          setContID(-1);
          setTransDescr("");
          setTransDtVencto("");
          setTransStatus("");
          setTransValor("");
          setContCgc_cpf("");
          setContNome("");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
    
        } else {alert("O seguinte erro foi retornado: "+resp.data.mensagem);}

      })
      .catch((err) => {
          alert('Falha ao gravar dados: '+err);
      });
  };
  
    return <form className="row g-3 needs-validation mt-0 mb-0" noValidate id={"pagar_codtransid_"+props.cod_transacao}>  
    {/* <div className="input-group" id={props.cod_transacao}> */}
      <div className="col-md-3">
        <div className="input-group mb-3">
          <input type="text" 
                 id={"cont_cnpj_pagar"+props.cod_transacao} 
                 className="form-control"   
                 value ={cont_cgc_cpf} 
                 onChange={(e)=>{setContCgc_cpf(e.target.value); setAlterado(true);}}
                 />
                 {/* defaultValue ={(props.cnpj==11) ? mask("###.###.###-##",props.cnpj) : mask("##.###.###/####-##",props.cnpj)} 
                 onChange={handleCnpj}/> */}
          {/* <MaskedInput              
              mascara="99.999.999/9999-99"
              value={props.cnpj}
              onChange={(event)=>setContCgc_cpf(event.target.value)}
              meuid={"cont_cnpj_pagar"+props.cod_transacao}/>           */}
          {/* <label for="cnpj" className="form-label">CNPJ</label> */}
          <button onClick={() => PesquisaCNPJ(document.getElementById("cont_cnpj_pagar"+props.cod_transacao).value,"cont_nome_pagar"+props.cod_transacao)} className="btn btn-outline-secondary btn-sm" type="button" id="button-addon2"><i className="bi bi-search"></i></button>
        </div>
      </div>
      <div className="col col-md-4" >
        {console.log('Pagar codTrans: '+props.cod_transacao)}
        {(props.cod_transacao <0) ?
        <input type="text" id={"cont_nome_pagar"+props.cod_transacao} 
               className="form-control" maxLength="40"
               value ={cont_nome} list="datalistContatos"
               onChange={(e) => setContNome(e.target.value)} 
        />:
        <input type="text" id={"cont_nome_pagar"+props.cod_transacao} 
               readOnly
               className="form-control" maxLength="40"
               value ={cont_nome} list="datalistContatos"
               onChange={(e) => setContNome(e.target.value)} 
        />        
        }
        
        <datalist id="datalistContatos">
          <option value="PIS"/>
          <option value="COFINS"/>
          <option value="IRPJ"/>
          <option value="CONTRIB.SOCIAL"/>
          <option value="ICMS"/>
          <option value="ISS"/>
          <option value="IPI"/>
          <option value="SIMPLES"/>
          <option value="IRRF"/>
          <option value="INSS"/>
          <option value="FGTS"/>
        </datalist>        
      </div>    
      <div className="col-md-2">
        {/* <label for="vencimento" className="form-label">Vencimento</label> */}
        <input type="date" id={"pagar_vencimento"+props.trans_valor}  className="form-control"   value ={trans_dt_vencto} onChange={(e) => {setTransDtVencto(e.target.value); setAlterado(true)}}/>
      </div>    
      <div className="col-md-2">
        <input              
          className="form-control" 
          value={trans_valor}
          //defaultValue={new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}).format(parseFloat(props.valor))}
          onChange={(e) => {setTransValor(e.target.value); setAlterado(true)}}
          id={"trans_valor_pagar"+props.cod_transacao}
          style={{"text-align": "right"}}/>  
      </div>    
      <div className="col-md-1" id="div-botoes-pagar">
        {((props.trans_valor<0) || alterado) ?
          <button onClick={() => SalvarPagar(props)} className="btn btn-primary btn-sm" type="button" id="button-salvar-pagar"><i className="bi bi-floppy"></i></button>
           :<></>}
        {/* {alterado && props.trans_valor>=0 ?
          <button onClick={() => SalvarAlteracaoPagar(props)} className="btn btn-primary btn-sm" type="button" id="button-salvar-pagar"><i className="bi bi-floppy"></i></button>
           :<></>} */}
        {props.trans_valor >= 0 ?
          <button onClick={() => ExcluirPagar(props)} className="btn btn-danger btn-sm" type="button" id="button-excluir-pagar"><i className="bi bi-trash3-fill"></i></button>
           :<></>} 
      </div>    
    </form>

}

export default Pagar; 

// confirmAlert({
//   title: 'Grava Dados',
//   message: 'Confirma inclusão destes dados?',
//   buttons: [
//     {
//       label: 'Sim',
//       onClick: () => {
//         api.post("/erp/pagar?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,pagar_params)
//         .then((resp) => {  //aguarda a resposta do comando get anterior
//           console.log("Resp do post na rota /erp/pagar: "+resp.data);
//           if (resp.status == 201){
//             props.onClose();
//             setAlterado(false);
//             setCodTransacao(-1);
//             setContID(-1);
//             setTransDescr("");
//             setTransDtVencto("");
//             setTransStatus("");
//             setTransValor("");
//             setContCgc_cpf("");
//             setContNome("");
//             setContEndereco("");
//             setContNumero("");
//             setContComplemento("");
//             setContBairro("");
//             setContCep("");
//             setContCidade("");
//             setContUf("");
//             setContResidencial("");
//             setContEmail("");
      
//           } else {alert("O seguinte erro foi retornado: "+resp.data.mensagem);}

//         })
//         .catch((err) => {
//             alert('Falha ao gravar dados: '+err);
//         });

//       }
//     },
//     {
//       label: 'Não',
//       onClick: () => {}
//     }
//   ]
// });
